var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"error-page fill-height"},[_c('v-row',{staticClass:"text-center",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('h1',[_vm._v(" 404 ")]),_c('v-img',{attrs:{"max-width":"640","max-height":"480","src":require("@/assets/404.jpg"),"contain":""}}),_c('div',[_vm._v(" 見つかりませんでした ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }